import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatTime } from '../../lib/utils';

const DurationTimer = ({ startTime }: { startTime: number }) => {
  const [duration, setDuration] = useState(0);
  const { t } = useTranslation();

  useEffect(() => {
    const interval = setInterval(() => {
      if (startTime > 0) {
        setDuration(Math.floor((Date.now() - startTime) / 1000));
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [startTime]);

  return <div className="text-sm text-gray-500">{formatTime(duration)}</div>;
};

export const Header = ({ category = undefined, scenario, startTime }) => {
  const { t } = useTranslation();

  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="bg-white border-b border-gray-200 px-6 py-4"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <h1 className="text-xl font-semibold text-gray-900">
            {category ?? scenario?.title}
          </h1>
          <DurationTimer startTime={startTime} />
        </div>

        <div className="flex items-center space-x-4">
          {/* Commented code updated with translations
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setShowTranscript(!showTranscript)}
          >
            <MessageSquare className="h-4 w-4 mr-2" />
            {showTranscript ? t('coach.header.transcript.hide') : t('coach.header.transcript.show')}
          </Button>

          <Button variant="ghost" size="sm" onClick={() => setIsMuted(!isMuted)}>
            {isMuted ? (
              <VolumeX className="h-4 w-4" title={t('coach.header.volume.unmute')} />
            ) : (
              <Volume2 className="h-4 w-4" title={t('coach.header.volume.mute')} />
            )}
          </Button> */}
        </div>
      </div>
    </motion.header>
  );
};
